<template>
  <div class="edit-reserve-service-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('editReserveService.title')" :subtitle="$t('editReserveService.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="handleCancel">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="handleSave">
          {{ $t('common.save') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (5) 表单面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('editReserveService.title') }}</span>
      </div>

      <el-form ref="form" :model="editReserveServiceInfo" label-width="120px" label-position="right" class="ds-form">
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('editReserveService.goodsName')" prop="goodsName">
              <el-input v-model.trim="editReserveServiceInfo.goodsName" clearable
                :placeholder="$t('editReserveService.goodsNamePlaceholder')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveService.params')" prop="paramsId">
              <el-select v-model="editReserveServiceInfo.paramsId" class="w-full"
                :placeholder="$t('editReserveService.paramsPlaceholder')">
                <el-option v-for="(item, index) in editReserveServiceInfo.reserveParamss" :key="index"
                  :label="item.name" :value="item.paramsId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveService.price')" prop="price">
              <el-input v-model.trim="editReserveServiceInfo.price" clearable
                :placeholder="$t('editReserveService.pricePlaceholder')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveService.sort')" prop="sort">
              <el-input v-model.trim="editReserveServiceInfo.sort" clearable
                :placeholder="$t('editReserveService.sortPlaceholder')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveService.state')" prop="state">
              <el-select v-model="editReserveServiceInfo.state" class="w-full"
                :placeholder="$t('editReserveService.statePlaceholder')">
                <el-option :label="$t('editReserveService.stateOff')" value="1001" />
                <el-option :label="$t('editReserveService.stateOn')" value="2002" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveService.startDate')" prop="startDate">
              <el-date-picker v-model="editReserveServiceInfo.startDate" type="datetime" class="w-full"
                value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('editReserveService.startDatePlaceholder')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveService.endDate')" prop="endDate">
              <el-date-picker v-model="editReserveServiceInfo.endDate" type="datetime" class="w-full"
                value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('editReserveService.endDatePlaceholder')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editReserveService.imgUrl')" prop="imgUrl">
              <upload-image-url ref="uploadImage" :limit="1"
                :default-images="[editReserveServiceInfo.imgUrl]"
                @notifyUploadCoverImage="handleImageChange" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('editReserveService.goodsDesc')" prop="goodsDesc">
              <el-input v-model="editReserveServiceInfo.goodsDesc" type="textarea" :rows="3"
                :placeholder="$t('editReserveService.goodsDescPlaceholder')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('editReserveService.content')" prop="content">
              <div class="editor-wrapper">
                <rich-text-editor ref="richTextEditor" v-model="editReserveServiceInfo.content" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- (7) 底部操作条 -->
      <div class="ds-form-actions">
        <el-button type="warning" @click="handleCancel">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button type="primary" @click="handleSave">
          {{ $t('common.save') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import RichTextEditor from '@/components/editor/RichTextEditor'
import { updateReserveGoods, listReserveParams, listReserveGoods } from '@/api/scm/editReserveServiceApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'EditReserveServiceList',
  components: {
    UploadImageUrl,
    RichTextEditor,
    DsPageHeader
  },
  data() {
    return {
      editReserveServiceInfo: {
        goodsId: '',
        goodsName: '',
        goodsDesc: '',
        type: '1001',
        paramsId: '',
        price: '',
        sort: '',
        state: '',
        startDate: '',
        endDate: '',
        imgUrl: '',
        catalogId: '',
        content: '',
        reserveParamss: []
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.editReserveServiceInfo.goodsId = this.$route.query.goodsId
    this.listReserveParamss()
    this.listReserveServices()
  },
  methods: {
    handleImageChange(images) {
      this.editReserveServiceInfo.imgUrl = images.length > 0 ? images[0] : ''
    },
    async listReserveParamss() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.communityId
        }
        const { data } = await listReserveParams(params)
        this.editReserveServiceInfo.reserveParamss = Array.isArray(data) ? data : []
      } catch (error) {
        console.error('获取参数列表失败:', error)
        this.$message.error(this.$t('editReserveService.loadParamsFailed'))
      }
    },
    async listReserveServices() {
      try {
        const params = {
          page: 1,
          row: 1,
          goodsId: this.editReserveServiceInfo.goodsId,
          communityId: this.communityId
        }
        const { data } = await listReserveGoods(params)
        if (data && data.length > 0) {
          Object.assign(this.editReserveServiceInfo, data[0])
          this.$refs.richTextEditor.setContent(this.editReserveServiceInfo.content)
          this.$refs.uploadImage.setImages([this.editReserveServiceInfo.imgUrl])
        }
      } catch (error) {
        console.error('获取服务详情失败:', error)
        this.$message.error(this.$t('editReserveService.loadServiceFailed'))
      }
    },
    validateForm() {
      const requiredFields = [
        'goodsName',
        'paramsId',
        'price',
        'sort',
        'startDate',
        'endDate',
        'imgUrl',
        'state',
        'goodsDesc',
        'content'
      ]

      for (const field of requiredFields) {
        if (!this.editReserveServiceInfo[field]) {
          this.$message.error(this.$t(`editReserveService.${field}Required`))
          return false
        }
      }
      return true
    },
    async handleSave() {
      try {
        if (!this.validateForm()) return

        this.editReserveServiceInfo.communityId = this.communityId
        const { code, msg } = await updateReserveGoods(this.editReserveServiceInfo)

        if (code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.$router.go(-1)
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error(this.$t('common.saveError'))
      }
    },
    handleCancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-reserve-service-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;

  &--padded {
    padding: var(--ds-spacing-lg);
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.editor-wrapper {
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-sm);
}

.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-md);
  padding-top: var(--ds-spacing-lg);
  margin-top: var(--ds-spacing-lg);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
